import React from "react";
import { useContent } from "@/context/ContentContext";

const NUMBER_FALLBACK = "27686760224";

export default function WhatsAppFloat() {
    const g = useContent().global || {};
    const number = g.whatsapp_number || NUMBER_FALLBACK;
    const message = encodeURIComponent("Hi Umami Kraft, I'd like to place an order.");
    return (
        <a
            href={`https://wa.me/${number}?text=${message}`}
            target="_blank"
            rel="noreferrer"
            data-testid="whatsapp-float"
            className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-brand-olive text-brand-cream px-4 py-3 rounded-sm shadow-lg hover:bg-brand-olive-deep transition-colors"
            aria-label="Chat on WhatsApp"
        >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.52 3.48A11.9 11.9 0 0012.06 0C5.51 0 .2 5.31.2 11.86c0 2.09.55 4.13 1.6 5.93L0 24l6.4-1.68a11.83 11.83 0 005.66 1.44h.01c6.55 0 11.86-5.31 11.86-11.86 0-3.17-1.23-6.15-3.41-8.42zM12.07 21.7h-.01a9.83 9.83 0 01-5.01-1.37l-.36-.21-3.79.99 1.01-3.69-.23-.38a9.82 9.82 0 01-1.51-5.18c0-5.44 4.43-9.86 9.87-9.86 2.63 0 5.1 1.03 6.96 2.89a9.79 9.79 0 012.89 6.97c0 5.43-4.43 9.84-9.82 9.84zm5.4-7.36c-.29-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.66.15-.19.29-.76.96-.94 1.16-.17.19-.34.22-.63.07-.29-.15-1.24-.46-2.36-1.46-.87-.78-1.46-1.74-1.63-2.03-.17-.29-.02-.44.13-.59.13-.13.29-.34.43-.51.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.15-.66-1.59-.91-2.18-.24-.58-.48-.5-.66-.51h-.56c-.19 0-.51.07-.77.36-.27.29-1.02 1-1.02 2.43s1.04 2.82 1.19 3.02c.15.19 2.06 3.15 5 4.42.7.3 1.24.48 1.66.61.7.22 1.34.19 1.84.11.56-.08 1.75-.72 2-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.21-.56-.35z"/>
            </svg>
            <span className="hidden sm:inline text-sm font-medium">WhatsApp Us</span>
        </a>
    );
}
